module.exports = __webpack_public_path__ + "static/media/shop.42fb4343.jpeg";